import React from "react";
import styles from "./uni_overview_about.module.scss";

export const UniOverviewAbout = () => {
  return (
    <section className={styles.section_about}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <div className="heading">
              <h2>Harvard University Overview</h2>
            </div>
            <img
              src="/assets/images/uni-profile/harvard-university.jpg"
              alt="University"
            />
            <p>
              Harvard University, established in 1636, is the oldest and one of
              the most famous institutions in the United States. A statue of
              John Harvard, College’s first patron, stands in front of
              University Hall in Harvard Yard and is perhaps the University’s
              best-known landmark. This Ivy League university carries its legacy
              from over 375 years not only in the United States but globally as
              well. Harvard currently has 12 degree-granting Schools in addition
              to the Radcliffe Institute for Advanced Study. The University has
              grown from nine students with a single master in the mid-1600s to
              an enrollment of more than 20,000-degree candidates including
              undergraduate, graduate, and professional students.
            </p>
            <p>
              With a campus size of 5457 acres, Harvard is based in
              Massachusetts, Cambridge. Organized around ancient city greens,
              tree-lined squares, and also the sedgy banks of the Charles River,
              Cambridge is one among metropolitan Boston’s very important urban
              centers. Harvard is at the center of Cambridge, giving individuals
              immediate access to the city’s dense mixture of retailers,
              restaurants, and diversion. Cambridge is an element of Boston’s
              comprehensive public transit. With buses, cabs, and a subway stop
              right in the middle of Harvard sq., you'll simply get anyplace you
              would like to travel. Downtown Beantown is simply a 12-minute ride
              from the field.
            </p>
            <p>
              Harvard has a diverse student population from over 50 states and
              80 countries and currently more than 36,000 students are studying
              at Harvard out of which 6,699 are enrolled in Harvard College,
              13,120 as graduate and professional students, and 16,193 in
              Harvard Extension School. Harvard has the oldest academic library
              in the world consisting of 20.4 million volumes, 180,000 serial
              titles, an estimated 400 million manuscript items, 10 million
              photographs, 124 million archived web pages, and 5.4 terabytes of
              born-digital archives and manuscripts. Approximately 70 percent of
              the students receive some sort of financial aid at Harvard, and
              about 60 percent receive need-based scholarships and pay an
              average of $12,000 per year. Harvard has an alumni base of more
              than 2.79 lakh in the US and 59,000 spread across 202 countries.
              It has about 2,400 world-class faculty members and more than
              10,400 academic appointments in affiliated teaching hospitals.
              Harvard has 48 Nobel Laureates, 32 heads of state, 48 Pulitzer
              Prize winners who have been affiliated as students, faculty, or
              researchers.
            </p>
          </div>
          <div className={styles.table_wrapper}>
            <table>
              <tbody>
                <tr>
                  <td>Total International Students</td>
                  <td>9,468</td>
                </tr>
                <tr>
                  <td>Size of Campus in acres</td>
                  <td>5457</td>
                </tr>
                <tr>
                  <td>Male/Female Ratio</td>
                  <td>1 : 0.94</td>
                </tr>
                <tr>
                  <td>UG/PG Course Ratio</td>
                  <td>1 : 4.56</td>
                </tr>
                <tr>
                  <td>Faculty/Student Ratio</td>
                  <td>1 : 7.0</td>
                </tr>
                <tr>
                  <td>Endowments Value</td>
                  <td>USD 37 billion</td>
                </tr>
                <tr>
                  <td>No.of Campuses</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>Yearly Hostel & Meals Expense</td>
                  <td>USD 15.5k</td>
                </tr>
                <tr>
                  <td>International Students Website</td>
                  <td>http://www.hio.harvard.edu</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniOverviewAbout;
